import createHousingCorporation from '$src/api/endpoints/housingCorporations/createHousingCorporation'
import {Component, React, observer} from '$src/handy'
import * as css from '../projects/CreateProjectModal.css'
import GenericModal from '$src/common/GenericModal'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import {applySnapshot, getSnapshot} from 'mobx-state-tree'

interface Props {
  projectId: string
  onRequestClose: Function
  onUpdateNeeded: Function
  history: any
  projectName: Function
}
// export default class ProjectsPage extends Component<{ history: any }, State> {
@observer
export default class AddProjectItemModal extends Component<
  Props,
  {error?: string; file?: any; submitting: boolean, itemId: string}
> {
  constructor(props: Props, context: any) {
    super(props, context)

    this.state = {error: undefined, file: undefined, submitting: false, itemId: ''}
  }

  onDrop = (files: any) => {
    this.setState({file: files[0]})
  }

  onSubmit = async (fields: any) => {
    this.setState({error: undefined})

    if (!fields.name) {
      this.setState({error: 'Choose a name for your project item'})
      return
    }

    this.setState({submitting: true})

    try {
      /**
       * Capitalize the first letter for the field data
       * (for the location coordinates to work properly)
       */
      const regex = /(\b[a-z](?!\s))/g

      const address = fields.address.replace(regex, function(field: string) {
        return field.toUpperCase()
      })

      const municipality = fields.municipality.replace(regex, function(
        field: string,
      ) {
        return field.toUpperCase()
      })

      const params = {
        parentId: this.props.projectId,
        name: fields.name,
        address,
        municipality,
        location: fields.location,
        comment: fields.comment,
        projectId: this.props.projectId,
        owned: false,
        constructionDate: '',
        ready: false,
        summaryAdjusted: false,
        hidden: false,
      }

      const createdHousingCorporation = await this.callEndpoint(
        createHousingCorporation,
        params,
      )
      this.store.housingCorporations.add(createdHousingCorporation)
      const listOfIds = getSnapshot(this.store.housingCorporations.list)

      try {
        applySnapshot(this.store.housingCorporations.list as $LibBugAny, [
          ...listOfIds,
        ])
      } catch (error) {
        console.log('ERROR: ', error)
      }

      this.setState({submitting: false})

      const allList = listOfIds.map((id: string) =>
        // @ts-ignore
        getSnapshot(this.store.housingCorporations.byId.get(id)),
      )

      allList.map(({name, _id}: {name: string, _id: string})=>{
        if(name === fields.name){
          this.setState({itemId: _id})
        }
      })

      this.props.history.push(
        `/comparable-sales-list/${this.props.projectId}/${this.props.projectName}/${this.state.itemId}`,
      )
      this.props.onUpdateNeeded()
      this.props.onRequestClose()
      
    } catch (error) {
      this.setState(s => ({
        ...s,
        error: error.message || 'Unauthorized',
        submitting: false,
      }))
    }
  }

  render() {
    return (
      <GenericModal
        onHide={this.props.onRequestClose}
        css={{box: {container: css.box}}}
      >
        <Form onSubmit={this.onSubmit} initialValues={undefined}>
          <TextInput.Field
            name="name"
            type="text"
            label="NAME"
            placeholder="Name"
          />

          <TextInput.Field
            name="address"
            type="text"
            label="ADDRESS"
            placeholder="Address"
          />

          <TextInput.Field
            name="municipality"
            type="text"
            label="MUNICIPALITY"
            placeholder="Municipality"
          />

          <TextInput.Field
            name="comment"
            type="text"
            label="COMMENT"
            placeholder="Comments"
          />

          {this.state.error && (
            <div className={css.error}>{this.state.error}</div>
          )}

          <div className={css.bottom}>
            <GenericButton
              variant="bold"
              type="submit"
              disabled={this.state.submitting}
            >
              ADD NEW ITEM
            </GenericButton>
          </div>
        </Form>
      </GenericModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/housingCorporations/AddItemModal.tsx